// extracted by mini-css-extract-plugin
export default {"loadingBox":"index_loadingBox_G-kTq","font":"index_font_zMrHG"};